import {
  selectReportingSessionId,
  selectReportingTeamId
} from '@frontend/core/lib/domains/reporting'
import {
  useAppDispatch,
  useAppSelector,
  useReportingTeamSessions
} from '@frontend/react'
import { Button, SearchableDropdown } from '@frontend/ui'
import { Loader } from 'lucide-react'
import { switchReportingSession } from '../lib/reporting-actions'

export function ReportingSessionSwitcher() {
  const dispatch = useAppDispatch()
  const teamId = useAppSelector(selectReportingTeamId) || ''
  const sessionId = useAppSelector(selectReportingSessionId) || ''
  const { options, isLoading, isFetching } = useReportingTeamSessions(teamId)

  if (!teamId || isLoading || (isFetching && options.length === 0)) {
    return (
      <Button
        variant='outline'
        disabled
        className='w-56 justify-start gap-2 bg-transparent'
      >
        <Loader className='h-4 w-4 animate-spin opacity-50' />
        <span className='text-muted-foreground truncate text-sm'>
          Loading sessions…
        </span>
      </Button>
    )
  }

  if (options.length === 0) return null

  const handleChange = (value: string | number | string[]) => {
    dispatch(switchReportingSession(value.toString() || null))
  }

  return (
    <SearchableDropdown
      options={options}
      value={sessionId}
      onSelect={handleChange}
      placeholder='Select session…'
      searchPlaceholder='Search sessions…'
      className='w-84'
      clearButton={false}
    />
  )
}
